// https://app.growthbook.io/features/copy_feature_variables
export const BOGO_OFFER_VARIABLES_FLAG_NAME = 'copy_feature_variables'

// Feature variables keys
export const GREEN_TEXT_KEY = 'text_and_offer_name_green'
export const ORANGE_TEXT_KEY = 'text_primary_orange'
export const LINK_KEY = 'link'
export const TEXT_KEY = 'text'
export const TEXT_SHORT_KEY = 'text_short'

// Feature variables
export const BANNER_OFFER_SLOGAN_BLUE_VARIABLE_NAME = 'banner_offer_slogan_blue'
export const OFFER_SLOGAN_YELLOW_VARIABLE_NAME = 'offer_slogan_yellow'
export const OFFER_TERMS_VARIABLE_NAME = 'offer_terms'
export const OFFER_TERMS_TEAL_VARIABLE_NAME = 'offer_terms_teal'
export const URGENCY_TEXTS_VARIABLE_NAME = 'urgency_texts'
export const URGENCY_TEXT_VARIABLE_NAME = 'urgency_text'
